var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.pagination && _vm.pagination.totalPages
    ? _c(
        "nav",
        {
          staticClass: "g-pagination",
          attrs: { "aria-label": "Pagination links" },
        },
        [
          _vm.pagination.totalPages > 1
            ? [
                _c("div", { staticClass: "g-pagination__item" }, [
                  _c(
                    "button",
                    {
                      staticClass:
                        "g-pagination__button g-pagination__previous",
                      attrs: {
                        type: "button",
                        title: _vm.previousText,
                        disabled: _vm.currentPage <= 1,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.previousPage()
                        },
                      },
                    },
                    [
                      _c("span", {
                        staticClass:
                          "g-pagination__button-icon u-icon-chevron-left",
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "u-hide-visually" }, [
                        _vm._v(_vm._s(_vm.previousText)),
                      ]),
                    ]
                  ),
                ]),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.pagination.totalPages > 1
            ? _vm._l(_vm.pages, function (page, index) {
                return _c(
                  "div",
                  { key: index, staticClass: "g-pagination__item" },
                  [
                    page.number === _vm.currentPage
                      ? [
                          _c(
                            "span",
                            {
                              staticClass:
                                "g-pagination__link g-pagination__link--active",
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t" +
                                  _vm._s(page.label) +
                                  "\n\t\t\t\t"
                              ),
                            ]
                          ),
                        ]
                      : [
                          _c(
                            "a",
                            {
                              staticClass: "g-pagination__link",
                              on: {
                                click: function ($event) {
                                  _vm.currentPage = page.number
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t" +
                                  _vm._s(page.label) +
                                  "\n\t\t\t\t"
                              ),
                            ]
                          ),
                        ],
                  ],
                  2
                )
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.pagination.totalPages > 1
            ? [
                _c("div", { staticClass: "g-pagination__item" }, [
                  _c(
                    "button",
                    {
                      staticClass: "g-pagination__button g-pagination__next",
                      attrs: {
                        type: "button",
                        title: _vm.nextText,
                        disabled: _vm.currentPage === _vm.pagination.totalPages,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.nextPage()
                        },
                      },
                    },
                    [
                      _c("span", {
                        staticClass:
                          "g-pagination__button-icon u-icon-chevron-right",
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "u-hide-visually" }, [
                        _vm._v(_vm._s(_vm.nextText)),
                      ]),
                    ]
                  ),
                ]),
              ]
            : _vm._e(),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }